import { Layout, Page } from "@shopify/polaris";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import SyncStatusTable from "../sync/SyncStatusTable";

const Dashboard = () => {  
  const [refreshSignal, setRefreshSignal] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  return (
    <Page
      title="Dashboard"
      primaryAction={{
        content: "Refresh",
        onAction: () => setRefreshSignal((current) => current + 1),
        loading: isRefreshing,
      }}
    >
      <Layout>
        <Layout.Section> 
          <SyncStatusTable
            refreshSignal={refreshSignal}
            onRefreshStateChange={setIsRefreshing}
          />
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default observer(Dashboard);
